import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkService } from '../shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class AuthServiceLocal {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();

  constructor(private networkService: NetworkService,
    ) { }

  Page(message: string) {
    this.pageChange.next(message)
  }
  validateLogin(req: any) {
    return this.networkService.login("auth/login", req, null, null);
  }
  getOrganisationById(id: string) {
    // Skip error handler to silently handle CORS errors
    return this.networkService.get("products", null, null, null, true);
  }
}
